import React from 'react';

export const LogoSpotify = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>Spotify Icon</title>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-936.000000, -609.000000)" fill="#FFFFFF" fillRule="nonzero">
                <g>
                    <g transform="translate(120.000000, 593.000000)">
                        <g transform="translate(812.000000, 12.000000)">
                            <g>
                                <g>
                                    <path d="M23.0978512,14.6378013 C19.229745,12.3408198 12.8494464,12.1294573 9.15696891,13.250148 C8.56386024,13.4299166 7.93681233,13.0952132 7.75718276,12.5022391 C7.5775532,11.908851 7.91197875,11.2823514 8.50536336,11.1021689 C12.7441796,9.81536816 19.7905701,10.0642572 24.2433691,12.7073932 C24.7767392,13.0240232 24.9516779,13.7127451 24.6356017,14.2452904 C24.3202152,14.7786637 23.6295657,14.9545692 23.0978512,14.6378013 Z M22.9717518,18.0401594 C22.7003759,18.480544 22.1245128,18.6186471 21.6848205,18.3482355 C18.4599041,16.3659525 13.5424413,15.7917417 9.72717552,16.949683 C9.23243541,17.0992372 8.70968854,16.8202717 8.55958335,16.3262185 C8.41058186,15.8314756 8.68954574,15.3099674 9.18345807,15.1594474 C13.5414755,13.8370517 18.959059,14.4776238 22.6632636,16.7539104 C23.1030938,17.024874 23.2421619,17.6010163 22.9713379,18.0401594 L22.9717518,18.0401594 Z M21.5029834,21.3073116 C21.2873452,21.6609162 20.8270961,21.7714262 20.4744593,21.5563387 C17.6565377,19.8341199 14.1097506,19.4447823 9.93274238,20.3992251 C9.53030041,20.4913858 9.12896215,20.2391855 9.03735384,19.8367412 C8.94519366,19.4342969 9.19628875,19.0330944 9.5999724,18.9413476 C14.1710068,17.8962617 18.0919532,18.346166 21.2550616,20.2787815 C21.6075605,20.4949729 21.7193115,20.9549486 21.5029834,21.3075875 L21.5029834,21.3073116 Z M16,4 C9.37274514,4 4,9.37236213 4,15.999793 C4,22.6277758 9.37246921,28 16,28 C22.6275308,28 28,22.6277758 28,15.999793 C28,9.37305195 22.6279446,4.00055185 16,4.00055185 L16,4 Z" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
